var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-select-div clear-float"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/home/keywordTop"}},[_vm._v("TOP100")])],1),_c('li',[_c('router-link',{attrs:{"to":"/home/weekly_keyword"}},[_vm._v("关键词")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }